import ReactQuill, { Quill } from 'react-quill';
import { ImageActions } from '@xeger/quill-image-actions';
import { ImageFormats } from '@xeger/quill-image-formats';
import 'react-quill/dist/quill.snow.css';

import { api, baseURL } from 'server-api';

import { useState, useMemo, useRef, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router';

import Button from 'components/button/Button'

//import ImageResize from 'quill-image-resize';
//Quill.register('modules/ImageResize', ImageResize);
Quill.register('modules/imageActions', ImageActions);
Quill.register('modules/imageFormats', ImageFormats);

export default function QEditor(props){
  const [selectedFile, setSelectedFile] = useState(null);
  const [title, setTitle] = useState('');
  const [body, setBody] = useState('');
  const [type, setType] = useState('projects');
  const [thumbnail, setThumbnail] = useState('');

  const titleRef = useRef();
  const bodyRef = useRef();
  const navigate = useNavigate();

  useEffect(()=>{
    setType(props.type?? 'projects');
  }, [props.type]);

  // 아이디가 넘어오면 게시글 수정
  const postId = props.postId ?? 0;
  useEffect(()=>{
    if(postId===0){ 
      return;
    }
    const get = async()=>{
      try{
        const response = await api.get(`/posts/${postId}`);
        if(response.status===200){
          setTitle(response.data.title);
          titleRef.current.value=response.data.title;
          setBody(response.data.body);
          setThumbnail(response.data.thumbnail);
          setType(response.data.type);
        }
      }catch(err){
        console.log(err);
        alert("오류가 발생했습니다.");
      }
    }
    get();
  },[postId]);

  const onSelectFile = (e)=>{
    const files = e.target.files;
    console.log(files[0]);
    setSelectedFile(files[0]);
  }

  const handleCancel = useCallback(()=>{
    navigate(-1);
  },[navigate]);

  const handleOk = ()=>{
    if(titleRef.current.value===''){
        alert('제목은 필수입니다.');
        return;
    }
    if(postId===0 && selectedFile==null){
      // 새 글 등록일 때는 썸네일 필수
      alert('썸네일을 지정해주세요.');
      return;
    } 
    if(bodyRef.current.value===''){
      alert('본문은 필수입니다.');
      return;
    }

    const formData = new FormData();
    formData.append('type', type);
    formData.append('title', titleRef.current.value);
    formData.append('body', body);
    if(selectedFile!=null)
      formData.append('img', selectedFile);
    
    const send = async(formData)=>{
      try{
        let url = `/posts`;
        let res = null;
        if(postId!==0){ 
          url+=`/${postId}`;
          res = await api.patch(url,formData, {
            headers:{
              "Content-Type": "multipart/form-data",
            },
          });
        }else {
          res = await api.post(url,formData, {
            headers:{
              "Content-Type": "multipart/form-data",
            },
          });
        };
        
        if(res.status===201 || res.status===200){
          alert('등록되었습니다.');
          navigate(-1);
        }
      }catch(error){
        console.log(error);
        alert('오류가 발생했습니다.');
      }
    }
    send(formData);
  };

  const imageHandler = () => {
    const input = document.createElement('input');
    input.setAttribute('type', 'file');
    input.setAttribute('accept', 'image/*');
    input.click();

    input.addEventListener('change', async () => {
      const file = input.files[0];

      try {
        const formData = new FormData();
        formData.append('img', file);
        const response = await api.post(`/uploads`, formData,{
          headers: {"Content-Type": "multipart/form-data",}
        });
        const imgUrl = response.data.url;
        const editor = bodyRef.current.getEditor(); 
        const range = editor.getSelection();
        editor.insertEmbed(range.index, 'image', `${baseURL}${imgUrl}`);
        editor.setSelection(range.index + 1);
      } catch (error) {
        console.log(error);
      }
    });
  };

  const formats = [
    'align',
    'background',
    'blockquote',
    'bold',
    'code-block',
    'color',
    'float',
    'font',
    'header',
    'height',
    'image',
    'italic',
    'link',
    'script',
    'strike',
    'size',
    'underline',
    'width',
    'image',
  ];
  const modules = useMemo(() => {
    return {
      imageActions: {},
      imageFormats: {},
      toolbar: {
        container: [
          ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
          [{ 'align': [] }],
          ['link', 'image'],
          [{ 'list': 'ordered'}, { 'list': 'bullet' }, { 'list': 'check' }],
          [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
          [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
          [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
          [{ 'font': [] }],

          ['clean']   
        ],
        //추가된 부분 이미지를 ImageHandler라는 함수로 직접 처리한다는 의미이다.
        handlers: {
          image: imageHandler,
        },
      },
      /*ImageResize: {
        parchment: Quill.import("parchment"),
        modules: ["Resize", "DisplaySize"],
      },*/
      history: {
        delay: 500,
        maxStack: 100,
        userOnly: true,
      },
    };
  }, []);
  return (
    <div className='flex flex-col'>
      <div className='flex flex-row'>
        <label htmlFor="title" className='w-20'>제목</label>
        <input type="text" id="title" name="title" ref={titleRef}
          className='border border-gray-400 focus:border-hover w-[700px]'/>
      </div>
      {/* thumbnail.length>0? 
        <div>
          <img src={`${baseURL}${thumbnail}`} style={{width:'300px'}} alt={title}/>
          <p className="text-sm text-gray-600">썸네일을 수정할 경우에만 파일을 선택하세요.</p>
        </div>
      :null */}
      <div className='flex flex-row my-4'>
        {thumbnail.length>0?
        <label htmlFor="thumbnail" className='w-20 text-red-500'>썸네일수정</label>
        :
        <label htmlFor="thumbnail" className='w-20'>썸네일</label>
        }
        
        <input type="file" id="thumbnail" name="thumbnail" onChange={onSelectFile}/>
      </div>
      <div className='h-[520px]'>
        <ReactQuill
          ref={bodyRef}
          style={{ width: "1200px", height: "450px" }}
          modules={modules}
          formats={formats}
          onChange={setBody}
          theme='snow'
          value={body}
        />
      </div>
      {localStorage.getItem('token')?
      <div className='flex justify-end mt-4'>
        <Button handler={handleCancel} type='light' className="mr-2">취소</Button>
        <Button handler={handleOk}>저장</Button>
      </div>
      :null}:
    </div>
  )
}